<template>
    <div class="max-w-120">
        <div class="kgr-alert kgr-alert--info kgr-row">
            {{ tInfoText }}
        </div>
        <div class="kgr-alert kgr-alert--warning kgr-row">
            {{ tWarningText }}
        </div>
        <kgr-form-row
            :label="tLabelEndDate"
            :error="error"
            field-name="endDate"
        >
            <div
                class="form-widget date-picker"
                :class="{ invalid: !data.endDate }"
            >
                <kgr-date-picker
                    v-model="data.endDate"
                    :disabled="loading"
                />
            </div>
        </kgr-form-row>
        <hr class="kgr-separator" />
        <div class="kgr-row">
            <button
                class="kgr-button"
                @click="$emit('onClose')"
            >
                {{ tButtonCancel }}
            </button>
            <button
                class="kgr-button"
                :disabled="!data.isValid()"
                @click="execute(true)"
            >
                <span>{{ tButtonExecuteTestRun }}</span>
            </button>
            <button
                class="kgr-button kgr-button--danger"
                :disabled="!data.isValid()"
                @click="execute(false)"
            >
                <span>{{ tButtonExecute }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import BatchEndMemberClubFees from './BatchEndMemberClubFees.js';
import DatePicker from '../../../../../common/form/picker/DatePicker';
import Error from '../../../../../../js/model/Error';
import FormRow from '../../../../../common/form/FormRow';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
    },
    props: {
        entityIds: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        savedActionData: {
            type: Object,
            required: false,
            default: () => null,
        },
    },
    data() {
        return {
            data: new BatchEndMemberClubFees(),
            error: new Error(),
        };
    },
    computed: {
        tInfoText() {
            return this.$t('Lists.actions.EndMemberClubFees.infoText', { count: this.entityIds.length });
        },
        tWarningText() {
            return this.$t('Lists.actions.EndMemberClubFees.warningText');
        },
        tLabelEndDate() {
            return this.$t('Lists.actions.EndMemberClubFees.form.endDate');
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        tButtonExecute() {
            return this.$t('Lists.actions.executeAction');
        },
        tButtonExecuteTestRun() {
            return this.$t('Lists.actions.executeTestRun');
        },
    },
    mounted() {
        this.assignDefaultData();
    },
    updated() {
        this.assignDefaultData();
    },
    methods: {
        execute(isTestRun) {
            if (!this.data.isValid()) {
                return;
            }
            this.$emit('executeAction', this.data, isTestRun);
        },
        assignDefaultData() {
            this.data.ids = this.entityIds;
            if (this.savedActionData !== null && this.savedActionData instanceof BatchEndMemberClubFees) {
                this.data = this.savedActionData;
            }
        },
    },
};
</script>
